<template>
  <div id="puestos" v-if="show">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <strong>Seleccione el puesto al que se postula</strong>
        </div>
      </div>
      <div class="card-body">
      </div>
      <div class="contenido">
        <div class="list-group">
          <div href="javascript:void(null)" class="list-group-item" v-for="puesto in puestos" :key="puesto.key">
            <a href="javascript:void(null)" @click="click({it: puesto, pm: 0})">{{ puesto.nombre }}</a>
            <div class="list-group" v-if="puesto.ch">
              <div class="list-group-item" v-for="pm in puesto.ch" :key="pm.key">
                <a href="javascript:void(null)" @click="click({it: pm, pm: 1})">{{ pm.nombre }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-center">
        <button class="btn btn-primary btn-sm" @click="cerrar">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from '../EventBus';
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      show: false
    }),
    computed: {
      ...mapGetters({
        puestos: 'sectores/getData'
      })
    },
    methods: {
      click: function(data) {
        let d = data.it;
        d.pm = data.pm;
        if(data.it.id!==2) {
          this.$store.commit('postulante/setSectorPostula', d);
        }else this.$store.commit('postulante/setSectorPostula', {});
        this.cerrar();
      },
      cerrar: function() {
        this.show = false;
      }
    },
    mounted() {
      //do something after mounting vue instance
      EventBus.$on('MOSTRAR_PUESTOS', (data) => {
        this.show = data;
      });
    }
  }
</script>

<style lang="sass" scoped>
  #puestos
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    width: 450px
    z-index: 99999999
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1)
    -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1)
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1)

    .contenido
      min-height: 250px !important
      max-height: 400px !important
      overflow: auto

    .card-title
      margin: 0 !important
    .list-group
      .list-group-item
        padding-top: 1px !important
        padding-bottom: 1px !important
        a
          font-size: 0.784rem !important
</style>



// WEBPACK FOOTER //
// src/components/Puestos.vue